import { apiMiddleware } from 'redux-api-middleware'
import { replace, routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const CASH_TOP_UP = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
  SAVE_MOBILE: null,
}, 'CASH_TOP_UP')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/u/unityInitPayPage',
        requestAction: CASH_TOP_UP.INIT_REQUEST,
        successAction: CASH_TOP_UP.INIT_SUCCESS,
        success: function(result) {},
      })
    )
    dispatch(queryResult(data))
  }
}

export function queryResult(data) {
  return (dispatch, getState) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/queryTradeOrderDetail',
        requestAction: CASH_TOP_UP.SUBMIT_REQUEST,
        successAction: CASH_TOP_UP.SUBMIT_SUCCESS,
        success: function(result) {
          if (getState().router.location.pathname !== '/cash-top-up') {
            return false
          }
          if (result.tradeStatus === 'S' || result.tradeStatus === 'F') {
            dispatch(replace(`/payments/result?ft=${data.token}`))
            return false
          }
          // 每5s轮询一次
          setTimeout(() => {
            dispatch(queryResult(data))
          }, 5000)
        },
      })
    )
  }
}

export function submit(data, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/u/setNotifyMobile',
        requestAction: CASH_TOP_UP.SUBMIT_REQUEST,
        successAction: CASH_TOP_UP.SUBMIT_SUCCESS,
        success: function(result) {
          dispatch({
            type: CASH_TOP_UP.SAVE_MOBILE,
            payload: { mobile: data.mobile },
          })
          callback()
        },
        // error: function(params) {
        //   callback()
        // }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CASH_TOP_UP.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [CASH_TOP_UP.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [CASH_TOP_UP.SUBMIT_REQUEST]: (state, action) => state,
  [CASH_TOP_UP.SUBMIT_SUCCESS]: (state, action) => state,
  [CASH_TOP_UP.SAVE_MOBILE]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'routesCashTopUp',
    reducerMap: {
      routesCashTopUpState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
